import { Project } from '@bulthaup/api/db';
import { Group, Switch, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';

import { trpc } from '../../../../../services/trpc';

export function ConstructionSiteCompliantSection({
  project,
}: {
  project: Project;
}) {
  const utils = trpc.useUtils();

  const update = trpc.projects.updateConstructionSiteCompliant.useMutation({
    onSuccess: () => {
      notifications.show({
        title: 'Succès',
        message: 'Conformité chantier mise à jour',
        color: 'green',
      });
      utils.projects.get.invalidate({ slug: project.slug });
    },
    onError: error => {
      notifications.show({
        title: 'Erreur',
        message: error.message,
        color: 'red',
      });
    },
  });

  const handleToggle = async (checked: boolean) => {
    await update.mutateAsync({
      id: project.id,
      isConstructionSiteCompliant: checked,
    });
  };

  return (
    <Group justify="space-between">
      <Text>Chantier conforme au plan technique :</Text>
      <Switch
        color="green"
        checked={project.isConstructionSiteCompliant}
        onChange={event => handleToggle(event.currentTarget.checked)}
        disabled={update.isPending}
      />
    </Group>
  );
}
